<template>
  <div id="app">
    <SiteHeader :appLoaded="appLoaded"/>
    <router-view
      :appLoaded="appLoaded"
      :appAnimations="appAnimations"
    />
    <vue-progress-bar
      class="progress-bar"
      ref="progressBar"
    />
    <SiteFooter
      :appLoaded="appLoaded"
      @animationCallbackReady="(callback) => appAnimations.push(callback)"/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'app',
  components: {
    SiteHeader,
    SiteFooter
  },
  data: function () {
    return {
      appAnimations: [],
      appLoaded: false
    }
  },
  created: function () {
    this.$Progress.start()
  },
  mounted: function () {
    this.$Progress.finish()
    this.$refs.progressBar.$el.classList.add('show')
    this.appLoaded = true
  }
}
</script>

<style lang="scss">
.progress-bar {
  bottom: $sz__site-footer-height !important;
  opacity: 1 !important;

  &.show {
    width: 100% !important;
  }
}
</style>
